import dayjs from 'dayjs';
import { age } from '../lib/freshness.ts';
import { count } from '../lib/format.ts';

/** What an environment with nothing in the last 24 hours holds: its newest document and everything it has. */
export interface History { newest: number | null; total: number; /** The class of the newest document: a query that finds data when an empty one finds nothing. */ cls?: string }

/** "The newest document is 3 d ago (5 Oct 17:29). This environment holds 2 970 807 documents." */
export function historyLine(h: History, now: number): string {
  const n = `${count(h.total)} ${h.total === 1 ? 'document' : 'documents'}`;
  if (h.newest === null) return `This environment holds ${n}.`;
  const when = dayjs(h.newest).format('D MMM HH:mm');
  return `The newest document is ${age(h.newest, now)} ago (${when}). This environment holds ${n}.`;
}

/** The hint of an environment with no documents at all. */
export function noDataHint(env: string | null | undefined): string {
  return env ? `Send a message to a vault of ${env}, or switch environment.` : 'Send a message to a vault of this environment, or switch environment.';
}
